import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface OrganizationStoreState {
  selectedOrganizationUuid: string | null;

  setSelectedOrganizationUuid: (uuid: string | null) => void;
  reset: () => void;
}

export const useOrganizationStore = create<OrganizationStoreState>()(
  devtools(
    (set) => ({
      selectedOrganizationUuid: null,

      setSelectedOrganizationUuid: (uuid) => set({ selectedOrganizationUuid: uuid }),

      reset: () => set({ selectedOrganizationUuid: null }),
    }),
    { name: "OrganizationStore" },
  ),
);
